import { Badge, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import React from 'react';
import Blink from 'react-blink-text';
import DialogSlideAlertas from './DialogSlideAlertas';

const styles = theme => ({
  buttonOperation: {
    fontSize: 'small',
    margin: theme.spacing(0.25),
    marginRight: theme.spacing(0.5),
    padding: theme.spacing(0.25),
    minWidth: theme.spacing(3),
    maxWidth: theme.spacing(3),
    minHeight: theme.spacing(3),
    maxHeight: theme.spacing(3),
  },
  badge: {
    top: '5%',
    right: 5,
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: theme.palette.secondary.main,
    backgroundColor: 'transparent',
  },
});

class ButtonAlertas extends React.Component {
  state = {
    dialogOpen: false
  }

  handleClick = () => {
    this.setState({dialogOpen: true});
  }

  handleCloseDialog = () => {
    this.setState({dialogOpen: false});
  }
  _possuiAlertaCobrancaDuplicada = (alertas) => {
    let possuiAlertaCobrancaDuplicada = false;
    for (var i = 0; i < alertas.length; i++) {
      if (alertas[i].desAlertaSistema.substring(0, 49) === 'O mesmo procedimento, com a mesma data de serviço' ||
          alertas[i].desAlertaSistema.substring(0, 72) === 'O mesmo item, com a mesma data de serviço, já foi cobrado na(s) guia(s):') {
        possuiAlertaCobrancaDuplicada = true;
      }
    }
    return possuiAlertaCobrancaDuplicada;
  }

  render () {
    const { classes, title, alertas, handleViewDuplicidades } = this.props;

    return (
      alertas && alertas.length > 0 &&
      <React.Fragment>
        <Badge badgeContent={this._possuiAlertaCobrancaDuplicada(alertas) ? <Blink color='secondary' text={alertas.length} fontSize='17px' /> : alertas.length} color='secondary' classes={{ badge: classes.badge }}>
          <Button
            color='secondary'
            className={classes.buttonOperation}
            title='Alertas do item'
            onClick={this.handleClick}>
            <ErrorOutline />
          </Button>
        </Badge>
        <DialogSlideAlertas
          open={this.state.dialogOpen}
          title={title}
          alertas={alertas}
          handleClose={this.handleCloseDialog}
          handleViewDuplicidades={() => {
            this.handleCloseDialog();
            handleViewDuplicidades();
          }
          }
        />
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ButtonAlertas);
